// React Components
import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Ant Design Components
import { Spin } from 'antd';

// Actions
import PaymentOutgoingActions from '@Actions/paymentOutgoingActions';
import invoiceActions from '@Actions/invoiceActions';
import AttachmentActions from '@Actions/attachmentActions';

// Utilities & Helpers
import Helpers from '@Apis/helpers';

// Payment Components
import ViewIncomingPaymentFooter from './ViewIncomingPaymentFooter';
import ViewIncomingPaymentHeader from './ViewIncomingPaymentHeader';
import ViewIncomingPaymentDetails from './ViewIncomingPaymentDetails';
import ViewIncomingPaymentLines from './ViewIncomingPaymentLines';

// Styles
import './style.scss';

const ViewIncomingPayment = (props) => {
  const {
    user,
    getPaymentOutgoingById,
    selectedPaymentId,
    selectedAttachment,
    getAttachmentById,
    updateAttachment,
    unlinkIncomingPayment,
    unLinkPayment,
    selectedPaymentOutgoing,
    getPaymentOutgoingByIdLoading,
    callback,
    unlinkIncomingPaymentLoading,
    paymentType,
    isQuickView,
    selectPaymentTenant,
    updatePaymentsOutgoingStatus,
    updatePaymentsOutgoingStatusLoading,
    MONEY,
    getAttachmentByIdLoading,
    updateAttachmentLoading,
  } = props;

  const [fileList, setFileList] = useState([]);
  const [isGetAttachment, setIsGetAttachment] = useState(false);
  const [isUserReadyForPrefillData, setIsUserReadyForPrefillData] = useState(false);

  useEffect(() => {
    const tenantIds = Helpers.getTenantEntityPermission(
      user?.user_tenants,
      Helpers.permissionEntities.CUSTOMER_PAYMENTS,
      Helpers.permissionTypes.READ
    ).join(',');

    getPaymentOutgoingById(tenantIds, selectedPaymentId, null, paymentType);

    getAttachmentById(selectedPaymentId, 'payment_outgoing', () => {
      setIsGetAttachment(true);
      setFileList(selectedAttachment);
    });
  }, [selectedPaymentId]);

  useEffect(() => {
    if (selectedPaymentOutgoing && !isUserReadyForPrefillData) {
      setFileList(selectedPaymentOutgoing?.attachments || []);
      setIsUserReadyForPrefillData(true);
    }
  }, [selectedPaymentOutgoing]);

  useEffect(() => {
    if (selectedAttachment && isGetAttachment && !getAttachmentByIdLoading && !updateAttachmentLoading) {
      setFileList(selectedAttachment);
      setIsGetAttachment(false);
    }
  }, [selectedAttachment, isGetAttachment, getAttachmentByIdLoading, updateAttachmentLoading]);

  const handleUnLinkPayment = (invoicePaymentId) => {
    unlinkIncomingPayment(invoicePaymentId, () => {
      const tenantIds = Helpers.getTenantEntityPermission(
        user?.user_tenants,
        Helpers.permissionEntities.CUSTOMER_PAYMENTS,
        Helpers.permissionTypes.READ
      ).join(',');

      getPaymentOutgoingById(tenantIds, selectedPaymentId, null, paymentType);
      callback();
    });
  };

  const handleUnLinkPaymentGRN = (grnPaymentId) => {
    unLinkPayment(grnPaymentId, () => {
      const tenantIds = Helpers.getTenantEntityPermission(
        user?.user_tenants,
        Helpers.permissionEntities.CUSTOMER_PAYMENTS,
        Helpers.permissionTypes.READ
      ).join(',');

      getPaymentOutgoingById(tenantIds, selectedPaymentId, null);
      callback();
    });
  };

  const handleFileChange = (fileListData) => {
    const newFileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    const attachments = newFileList?.map((attachment) => ({
      url: attachment?.url,
      type: attachment?.type,
      name: attachment?.name,
      uid: attachment?.uid,
    }));

    const payload = {
      entity_id: selectedPaymentOutgoing?.payment_id,
      entity_name: 'payment_outgoing',
      attachments,
    };

    if (fileListData?.file.status === 'done' || fileListData?.file.status === 'removed') {
      updateAttachment(payload, () => {
        getAttachmentById(selectedPaymentOutgoing?.payment_id, 'payment_outgoing', () => {
          setIsGetAttachment(true);
        });
      });
    }

    setFileList(attachments.length > 0 ? attachments : []);
  };

  if (getPaymentOutgoingByIdLoading) {
    return (
      <div className="view-incoming-payment__loader">
        <Spin />
      </div>
    );
  }

  return (
    <Fragment>
      {selectedPaymentOutgoing?.payment_id && (
        <div className="view-document__wrapper">
          <div className="ant-row">
            <div className="view-left__wrapper">
              <ViewIncomingPaymentHeader
                user={user}
                isQuickView={isQuickView}
                paymentType={paymentType}
                callback={callback}
                updatePaymentsOutgoingStatus={updatePaymentsOutgoingStatus}
                updatePaymentsOutgoingStatusLoading={updatePaymentsOutgoingStatusLoading}
                selectedPaymentOutgoing={selectedPaymentOutgoing}
              />
              <ViewIncomingPaymentDetails
                selectedPaymentOutgoing={selectedPaymentOutgoing}
                MONEY={MONEY}
              />
              <br />
              <ViewIncomingPaymentLines
                selectedPaymentOutgoing={selectedPaymentOutgoing}
                selectPaymentTenant={selectPaymentTenant}
                handleUnLinkPayment={(val) => handleUnLinkPayment(val)}
                handleUnLinkPaymentGRN={(val) => handleUnLinkPaymentGRN(val)}
                unlinkIncomingPaymentLoading={unlinkIncomingPaymentLoading}
                MONEY={MONEY}
              />
              <ViewIncomingPaymentFooter
                fileList={fileList}
                getAttachmentByIdLoading={getAttachmentByIdLoading}
                updateAttachmentLoading={updateAttachmentLoading}
                selectedPaymentOutgoing={selectedPaymentOutgoing}
                handleFileChange={handleFileChange}
                MONEY={MONEY}
                user={user}
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers,
  PaymentOutgoingReducers,
  AttachmentReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  selectedPaymentOutgoing: PaymentOutgoingReducers.selectedPaymentOutgoing,
  getPaymentOutgoingByIdLoading: PaymentOutgoingReducers.getPaymentOutgoingByIdLoading,
  updatePaymentsOutgoingStatusLoading: PaymentOutgoingReducers.updatePaymentsOutgoingStatusLoading,
  unlinkIncomingPaymentLoading: PaymentOutgoingReducers.unlinkIncomingPaymentLoading,
  selectedAttachment: AttachmentReducers.selectedAttachment,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentOutgoingById: (tenantId, paymentId, callback, paymentType) =>
    dispatch(PaymentOutgoingActions.getPaymentOutgoingById(tenantId, paymentId, callback, paymentType)),
  updatePaymentsOutgoingStatus: (payload, action) =>
    dispatch(PaymentOutgoingActions.updatePaymentsOutgoingStatus(payload, action)),
  unlinkIncomingPayment: (grnPaymentId, callback) =>
    dispatch(invoiceActions.unlinkIncomingPayment(grnPaymentId, callback)),
  getAttachmentById: (entityId, entityName, callback) =>
    dispatch(AttachmentActions.getAttachmentById(entityId, entityName, callback)),
  updateAttachment: (payload, callback) =>
    dispatch(AttachmentActions.updateAttachment(payload, callback)),
  unLinkPayment: (grnPaymentId, callback) =>
    dispatch(PaymentOutgoingActions.unLinkPayment(grnPaymentId, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewIncomingPayment));
